var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAddCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "1aoc320jaa",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3c-4.99 0-9 4.01-9 9s4.01 9 9 9 9-4.01 9-9-4.01-9-9-9zm0 16.364A7.333 7.333 0 0 1 4.636 12 7.333 7.333 0 0 1 12 4.636 7.333 7.333 0 0 1 19.364 12 7.333 7.333 0 0 1 12 19.364zm3.273-6.546c.49 0 .818-.327.818-.818 0-.49-.327-.818-.818-.818h-2.455V8.727c0-.49-.327-.818-.818-.818-.49 0-.818.327-.818.818v2.455H8.727c-.49 0-.818.327-.818.818 0 .49.327.818.818.818h2.455v2.455c0 .49.327.818.818.818.49 0 .818-.327.818-.818v-2.455h2.455z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1aoc320jaa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h24v24H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddCircle);
export default __webpack_public_path__ + "static/media/ic_add_circle.9d5c50b43bd449c8ddc667d54b29f759.svg";
export { ForwardRef as ReactComponent };